import {
  addSeconds,
  differenceInHours,
  format,
  Locale,
  setDefaultOptions,
  startOfToday,
} from 'date-fns';

export function convertDateToString(
  date: Date | null | undefined,
  withTime?: boolean,
) {
  if (date === undefined) return undefined;

  if (!date) return '';

  return format(date, withTime === true ? "yyyy-MM-dd'T'HH:mm" : 'yyyy-MM-dd');
}

export const convertToShortDate = (date: Date) => {
  return format(date, 'do MMM');
};

export function formatDurationInSecondsAsHHMM(
  durationInSeconds: number,
): string {
  const startDate = startOfToday();
  const endDate = addSeconds(startOfToday(), durationInSeconds);
  return `${differenceInHours(startDate, endDate)}:${format(endDate, 'mm')}`;
}

export function setLocale(locale: Locale) {
  setDefaultOptions({ locale: locale });
}

import { enUS } from 'date-fns/locale';
// If we just set `format` of Material datepickers to e.g. 'f',
// it becomes impossible to edit it with keyboard (https://github.com/mui-org/material-ui-pickers/issues/2120).
// So we have to guess the format of the current locale.
export const dateFormat = () =>
  localFormat(new Date(2222, 11, 23), 'P')
    .replace('2222', 'yyyy')
    .replace('12', 'MM')
    .replace('23', 'dd');

export const dateTimeFormat = () =>
  dateFormat() +
  ' ' +
  localFormat(new Date(2222, 11, 23, 22, 15, 16), 'p')
    .replace('22', 'HH')
    .replace('10', 'hh')
    .replace('15', 'mm')
    .replace('16', 'ss')
    .replace(/pm/i, 'a');

export const dateTimeWithSecondsFormat = () =>
  dateFormat() +
  ' ' +
  localFormat(new Date(2222, 11, 23, 22, 15, 16), 'pp')
    .replace('22', 'HH')
    .replace('10', 'hh')
    .replace('15', 'mm')
    .replace('16', 'ss')
    .replace(/pm/i, 'a');

export function localFormat(date: Date, dateFormat: string): string {
  if (!date) return '';
  const browserLang = navigator.language;
  if (browserLang === 'en-US') {
    return format(date, dateFormat, { locale: enUS });
  }
  return format(date, dateFormat);
}
